import type { ReactNode } from "react"
import { useContext } from "react"

import { cn } from "@productlane/lib/src/cn"

import {
	SETTINGS_INSET_CLASS,
	SettingsCardInsetContext,
} from "./settings-container"

interface Props {
	children: ReactNode
	className?: string
}

// Aligns a full-width control (textarea, input) with the settings cards: bleeds
// 14px on sm+, stays within the page padding on mobile. Mirrors SettingsContainer.
export const SettingsInset = ({ children, className }: Props) => {
	const inset = useContext(SettingsCardInsetContext)
	return (
		<div className={cn(inset && SETTINGS_INSET_CLASS, className)}>
			{children}
		</div>
	)
}
